import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import { teamMembers } from '@/mocks/team';

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget as HTMLFormElement;

    const honeypotInput = form.querySelector<HTMLInputElement>('input[name="phone_alt"]');
    if (honeypotInput && honeypotInput.value.trim() !== '') {
      setFormStatus('success');
      setTimeout(() => setFormStatus('idle'), 5000);
      return;
    }

    const formData = new FormData(form);
    if (honeypotInput) {
      formData.delete('phone_alt');
    }

    try {
      const response = await fetch('https://readdy.ai/api/form/d9u37ddca23r0tr1apk0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed && parsed.code === 'OK') {
        setFormStatus('success');
        form.reset();
        setTimeout(() => setFormStatus('idle'), 5000);
      } else {
        const serverMsg =
          parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '提交失败，请稍后重试';
        if (serverMsg.includes('spam') || serverMsg.includes('form data is spam')) {
          setFormError('提交失败，请稍后重试');
        } else {
          setFormError(serverMsg);
        }
        setFormStatus('error');
      }
    } catch {
      setFormError('网络错误，请检查连接后重试');
      setFormStatus('error');
    }
  };

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '关于我们' }]} />

        <section className="px-4 md:px-6 py-10 md:py-16 bg-background-50">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-3xl md:text-4xl font-heading text-foreground-900 mb-4">
              关于 约炮攻略
            </h1>
            <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto leading-relaxed">
              我们是一群热爱社交、相信真诚连接的人。约炮攻略致力于为成年人提供真实有效的约会技巧、平台推荐和安全指南，帮助每个人更自信、更安全地享受社交生活。
            </p>
          </div>
        </section>

        <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-8 text-center">
              我们的理念
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {[
                {
                  icon: 'ri-heart-line',
                  title: '真诚连接',
                  desc: '我们相信每一次约会都应该是真诚的互动，而非功利的交易。尊重和平等是约会的基石。',
                  color: 'primary',
                },
                {
                  icon: 'ri-shield-check-line',
                  title: '安全第一',
                  desc: '安全是我们所有建议的核心前提。从平台选择到见面安排，安全永远是第一考量。',
                  color: 'accent',
                },
                {
                  icon: 'ri-lightbulb-flash-line',
                  title: '持续学习',
                  desc: '社交能力是可以学习和提升的。我们持续分享最新的约会策略和社交技巧，帮助每个人变得更好。',
                  color: 'secondary',
                },
              ].map((item) => {
                const iconBg =
                  item.color === 'accent'
                    ? 'bg-accent-100 text-accent-700'
                    : item.color === 'secondary'
                      ? 'bg-secondary-100 text-secondary-700'
                      : 'bg-primary-100 text-primary-700';
                return (
                  <div
                    key={item.title}
                    className="p-6 rounded-lg bg-background-50 border border-background-200/70 text-center"
                  >
                    <div className={`w-12 h-12 rounded-lg flex items-center justify-center mx-auto mb-4 ${iconBg}`}>
                      <i className={`${item.icon} text-xl`}></i>
                    </div>
                    <h3 className="text-lg font-heading text-foreground-900 mb-2">{item.title}</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        <section className="px-4 md:px-6 py-10 md:py-14 bg-background-50">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-8 text-center">
              我们的团队
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {teamMembers.map((member) => (
                <div
                  key={member.name}
                  className="p-6 rounded-lg bg-background-50 border border-background-200/70 text-center"
                >
                  <div className="w-20 h-20 rounded-full overflow-hidden mx-auto mb-4">
                    <img
                      src={member.imageUrl}
                      alt={member.name}
                      title={member.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <h3 className="text-base font-heading text-foreground-900 mb-1">{member.name}</h3>
                  <p className="text-xs text-primary-500 font-medium mb-2">{member.role}</p>
                  <p className="text-sm text-foreground-600 leading-relaxed">{member.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-2xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3 text-center">
              联系我们
            </h2>
            <p className="text-sm text-foreground-600 text-center mb-8">
              如果你有任何问题、建议或合作意向，欢迎通过以下表单联系我们。
            </p>

            {formStatus === 'success' ? (
              <div className="text-center py-10">
                <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-check-line text-2xl text-green-600"></i>
                </div>
                <h3 className="text-lg font-heading text-foreground-900 mb-2">提交成功！</h3>
                <p className="text-sm text-foreground-600">感谢你的留言，我们会尽快回复。</p>
              </div>
            ) : (
              <form
                onSubmit={handleSubmit}
                data-readdy-form
                id="contact-form"
                className="space-y-4"
              >
                {formStatus === 'error' && formError && (
                  <div className="p-3 rounded-lg bg-red-50 border border-red-200 text-sm text-red-700">
                    {formError}
                  </div>
                )}

                <input
                  type="text"
                  name="phone_alt"
                  className="form-honeypot"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                />

                <div>
                  <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    你的称呼 <span className="text-primary-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="contact-name"
                    name="name"
                    required
                    className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                    placeholder="请输入你的称呼"
                  />
                </div>

                <div>
                  <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    电子邮箱 <span className="text-primary-500">*</span>
                  </label>
                  <input
                    type="email"
                    id="contact-email"
                    name="email"
                    required
                    className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                    placeholder="请输入你的电子邮箱"
                  />
                </div>

                <div>
                  <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    主题
                  </label>
                  <input
                    type="text"
                    id="contact-subject"
                    name="subject"
                    className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                    placeholder="请输入主题"
                  />
                </div>

                <div>
                  <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    留言内容 <span className="text-primary-500">*</span>
                  </label>
                  <textarea
                    id="contact-message"
                    name="message"
                    required
                    maxLength={500}
                    rows={5}
                    className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                    placeholder="请输入你的留言内容（最多500字）"
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="w-full py-3 bg-primary-500 text-white rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  提交留言
                </button>
              </form>
            )}
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于我们 - 约炮攻略',
            description: '约炮攻略团队介绍、品牌理念和联系方式',
            url: 'https://pairfinder.github.io/about',
            isPartOf: {
              '@type': 'WebSite',
              name: '约炮攻略',
              url: 'https://pairfinder.github.io/',
            },
          }),
        }}
      />
    </>
  );
}